import type { FC } from 'react';
import { IcListDot } from '@yanolja-rnd/nol-icons';

/*
 * Feature
 * 사용 영역: 국내숙소, 레저, 해외숙소
 * 타입 정보: Banner, List
 */

export interface UnitFeatureProps {
  descriptions?: string[] | null;
}

export const UnitFeature: FC<UnitFeatureProps> = ({ descriptions }) => {
  if (!descriptions) return null;

  return (
    <div className="mt-12 flex w-full flex-1 flex-col-reverse">
      <div className="flex w-full flex-col gap-6 rounded-8 bg-fill-neutral-weak px-8 py-8">
        {descriptions.map((description) => (
          <div
            key={description}
            className="flex items-start justify-start gap-2 text-text-neutral-main typography-body-14-regular">
            <IcListDot width={14} height={14} className="shrink-0 text-fill-neutral-strong1" />
            <span className="line-clamp-1 text-start text-text-neutral-sub typography-body-12-regular">
              {description}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
